import React, { useEffect, useMemo, useState } from 'react';
import api from '../api';
import './estilodash.css';

export default function AdicionaPagamentos() {
  const [clientes, setClientes] = useState([]);
  const [assinaturas, setAssinaturas] = useState([]);
  const [form, setForm] = useState({ cliente_id: '', assinatura_id: '', mes_referencia: '', data_pagamento: '', valor: '', descricao: '', metodo_pagamento: 'PIX', status: 'Aguardando pagamento' });
  const [msg, setMsg] = useState('');

  useEffect(() => {
    Promise.all([api.get('/api/clientes'), api.get('/api/assinaturas')]).then(([c,a]) => {
      setClientes(c.data || []);
      setAssinaturas(a.data || []);
      const hoje = new Date();
      const yyyy = hoje.getFullYear();
      const mm = String(hoje.getMonth() + 1).padStart(2, '0');
      const dd = String(hoje.getDate()).padStart(2, '0');
      setForm(f => ({ ...f, data_pagamento: `${yyyy}-${mm}-${dd}`, mes_referencia: `${yyyy}-${mm}` }));
    }).catch(console.error);
  }, []);

  const assinaturasCliente = useMemo(() => assinaturas.filter(a => String(a.cliente_id) === String(form.cliente_id)), [assinaturas, form.cliente_id]);

  const salvar = async (e) => {
    e.preventDefault();
    const body = {
      ...form,
      cliente_id: Number(form.cliente_id),
      assinatura_id: form.assinatura_id ? Number(form.assinatura_id) : null,
      origem_cobranca: form.assinatura_id ? 'assinatura' : 'cliente',
      valor: Number(form.valor || 0),
    };
    await api.post('/api/pagamentos', body);
    setMsg('Pagamento cadastrado com sucesso.');
  };

  return (
    <div>
      <h2>Adicionar Pagamento</h2>
      <p>Use assinatura_id sempre que possível. Isso garante o financeiro correto no modelo novo.</p>
      {msg && <p>{msg}</p>}
      <form onSubmit={salvar}>
        <div className="form-linha">
          <label>Cliente
            <select value={form.cliente_id} onChange={(e) => setForm({ ...form, cliente_id: e.target.value, assinatura_id: '' })}>
              <option value="">Selecione</option>
              {clientes.map(c => <option key={c.id} value={c.id}>{c.id} - {c.nome}</option>)}
            </select>
          </label>
          <label>Assinatura
            <select value={form.assinatura_id} onChange={(e) => setForm({ ...form, assinatura_id: e.target.value })}>
              <option value="">Sem assinatura</option>
              {assinaturasCliente.map(a => <option key={a.id} value={a.id}>{a.nome_plano || a.codigo_plano} ({a.tier})</option>)}
            </select>
          </label>
        </div>
        <div className="form-linha">
          <label>Mês referência
            <input type="month" value={form.mes_referencia} onChange={(e) => setForm({ ...form, mes_referencia: e.target.value })} />
          </label>
          <label>Data
            <input type="date" value={form.data_pagamento} onChange={(e) => setForm({ ...form, data_pagamento: e.target.value })} />
          </label>
          <label>Valor
            <input value={form.valor} onChange={(e) => setForm({ ...form, valor: e.target.value })} />
          </label>
        </div>
        <div className="form-linha">
          <label>Método
            <select value={form.metodo_pagamento} onChange={(e) => setForm({ ...form, metodo_pagamento: e.target.value })}>
              <option value="PIX">PIX</option>
              <option value="Cartão">Cartão</option>
              <option value="Transferência">Transferência</option>
            </select>
          </label>
          <label>Status
            <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
              <option value="Aguardando pagamento">Aguardando pagamento</option>
              <option value="Pago">Pago</option>
              <option value="Isento">Isento</option>
              <option value="Cancelado">Cancelado</option>
            </select>
          </label>
        </div>
        <label>Descrição
          <textarea value={form.descricao} onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
        </label>
        <button type="submit">Salvar pagamento</button>
      </form>
    </div>
  );
}
